import { render, staticRenderFns } from "./tanimla.vue?vue&type=template&id=519d023a&scoped=true&"
import script from "./tanimla.vue?vue&type=script&lang=js&"
export * from "./tanimla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519d023a",
  null
  
)

export default component.exports